#import "../../../graphql/fragments/coordinates-fragment.graphql"
#import "../../../graphql/fragments/location-weather-fragment.graphql"

query GetContactLocationData($id: ID!) {
    contact(id: $id) {
        id
        postalAddresses {
            primary {
                location {
                    coordinates {
                        ...CoordinatesFragment
                    }
                    weather {
                        ...LocationWeatherFragment
                    }
                }
            }
        }
    }
}
